import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { engineComponent, ArrayUtils } from "neo-common";
import { SwitchElement, SwitchElementAttributes } from "../Components/Elements/Graphics/SwitchElement";
import { ShapeElement } from "../Components/Elements/Graphics/ShapeElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";

@engineComponent(ComponentTypes.DisplayObject)
export class GroupTweens extends BaseElement {
    static CaseInit: string = "INIT";
    static CaseInitIntro: string = "INIT_INTRO";
    static CaseIntro: string = "INTRO";
    static CaseNormal: string = "NORMAL";
    static CaseBaseToFreespins: string = "BASE_TO_FREESPINS";
    static CaseFreespinsToBase: string = "FREESPINS_TO_BASE";
    static CaseGambleInit: string = "GAMBLE_INIT";
    static CaseBaseToGamble: string = "BASE_TO_GAMBLE";
    static CaseBaseToGambleHighWins: string = "BASE_TO_GAMBLE_HIGHWINS";
    static CaseBaseToGambleWins: string = "BASE_TO_GAMBLE_WINS";
    static CaseGambleToBase: string = "GAMBLE_TO_BASE";
    static CaseBaseToPickIN: string = "BASE_TO_PICK_IN";
    static CaseBaseToPickOUT: string = "BASE_TO_PICK_OUT";
    static CasePickToFreespinsIN: string = "PICK_TO_FREESPINS_IN";
    static CasePickToFreespinsOUT: string = "PICK_TO_FREESPINS_OUT";
    static CaseFreespinsToBaseIN: string = "FREESPINS_TO_BASE_IN";
    static CaseFreespinsToBaseOUT: string = "FREESPINS_TO_BASE_OUT";
    static CaseFreespinsMessageEnd: string = "FREESPINS_MESSAGE_END";
    static CaseFreespinsMessageEndInit: string = "FREESPINS_MESSAGE_END_INIT";
    static CaseTeasing: string = "TEASING";
    static CaseWin: string = "WIN";

    private _childs: Object;
    private _childsNamesAccepted: Array<string>;

    constructor() {
        super();

        this._childs = [];
    }

    public createByNode(node: Element): void {
        super.createByNode(node);

        if (node.hasAttribute(GroupTweensAttributes.ELEMENT_NAMES)) {
            this._childsNamesAccepted = node.getAttribute(GroupTweensAttributes.ELEMENT_NAMES).split(";");
        }
    }

    public updateByNode(node: Element): void {
        //super.updateByNode(node);

        if (this._childs && this._childsNamesAccepted) {
            this._childsNamesAccepted.forEach((value) => {
                if (this._childs[value]) {
                    if (this._childs[value] instanceof ImageElement || BaseElement || ShapeElement) {
                        this._childs[value].updateByNode(node);
                    }
                }
            });
        }
    }

    public setChilds(childs: Object): void {
        this._childs = childs;
    }
}

const GroupTweensAttributes = {
    ELEMENT_NAMES: "ElementNames",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/GroupTweens.ts
 **/